import React from "react";
import {Admission} from "~/queries";
import {Card, CardActionArea, CardContent, Divider, Grid, Typography} from "@mui/material";
import {formatDate} from "~/apps/core/utils";
import moment from "moment";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import {TypographyWithIcon} from "~/apps/core/ui/TypographyWithIcon";
import {NavigateNext} from "@mui/icons-material";
import {makeStyles} from "@mui/styles";
import {VehicleNumber} from "~/apps/core/ui/VehicleNumber";
import {useHistory} from "react-router-dom";
import {Tag} from "~/apps/core/ui/Tag";
import {AdmissionStatusBadge} from "~/apps/packages/passes/components/AdmissionStatusBadge";


export type AdmissionItemProps = {
    admission: Admission
}


const useStyles = makeStyles(() => ({
    root: {
        width: "100%",
    }
}));


export const AdmissionItem = (props: AdmissionItemProps) => {
    const history = useHistory();
    const {admission, ...other} = props;
    const classes = useStyles();

    const handleClick = () => {
        history.push(`/${admission.id}`);
    }

    return (
        <Card className={classes.root}>
            <CardActionArea onClick={handleClick}>
                <CardContent>
                    <Grid container direction="column" wrap="nowrap" rowSpacing="8px">
                        <Grid item container direction="row" justifyContent="space-between">
                            <Grid item>
                                <AdmissionStatusBadge>
                                    {admission.status}
                                </AdmissionStatusBadge>
                            </Grid>
                            <Grid item>
                                <Typography variant="cardText">
                                    {formatDate(moment(admission.passDate, "YYYY-MM-DD"))}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item container direction="row" justifyContent="space-between">
                            <Grid item>
                                <Typography variant="cardTitle2" color="#232326">
                                    <Tag>
                                        {admission.carRegNumber ? "Автомобильный" : "Пешеходный"}
                                    </Tag>
                                </Typography>
                            </Grid>
                            {admission.carRegNumber && (
                                <Grid item>
                                    <VehicleNumber number={admission.carRegNumber}/>
                                </Grid>
                            )}
                        </Grid>
                        <Grid item>
                            <Divider/>
                        </Grid>
                        <Grid item>
                            <TypographyWithLabel label="ФИО">
                                {admission.fullName}
                            </TypographyWithLabel>
                        </Grid>
                        <Grid item alignSelf="flex-end">
                            <TypographyWithIcon endIcon={<NavigateNext/>} color="textSecondary" variant="cardText" marginRight="-8px" marginBottom="-2px">
                                Подробнее
                            </TypographyWithIcon>
                        </Grid>
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
    )
}